import { BrowserRouter, Routes, Route } from "react-router-dom";
import NOAVerified from "./components/Verification/NOAVerified";
import RateVerification from "./components/Verification/RateVerified";
import LandingPage from "./components/Verification/LandingPage";

/**
 * The App
 * @author Jeremiah Liscum
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/verification" element={<RateVerification />} />
        <Route path="/noa-verification" element={<NOAVerified />} />
        <Route path="/rate-verification" element={<RateVerification />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;